<template>
  <div class="faq-with-toolbar">
    <v-container fluid class="toolbar">
      <v-row class="child-flex">
        <v-toolbar flat>
          <div class="toolbar-title text-left">
            <button class="btn" @click="closeIOSWebView">Back</button>
          </div>
          <div class="toolbar-title text-center mx-auto">
            {{ $t('faq', 'title') }}
          </div>
        </v-toolbar>
      </v-row>
    </v-container>
    <div class="faq-page">          
          <v-expansion-panels multiple>
            <v-expansion-panel v-for="(faq, i) in faqList" :key="`faq-${i}`" class="faq-panel mb-4">
              <v-expansion-panel-header class="faq-header">
                <strong>Q{{ i + 1 }}.{{ faq.q }}</strong>
                <template #actions>
                  <v-icon color="white">mdi-chevron-down</v-icon>
                </template>
              </v-expansion-panel-header>
            <v-expansion-panel-content class="faq-content pa-4" style="line-height: 2.8">
            <template v-for="(item, j) in faq.a" :key="`faq-${i}-line-${j}`" class="mb-3">
              <template v-if="item.type === 'text'">
                <div v-html="item.text" class="faq-line"></div>                                
              </template>
              <template v-else-if="item.type === 'image'">
                <img :src="item.src" :alt="item.alt" class="faq-image" loading="lazy">
              </template>
              <template v-else-if="item.type === 'video'">
                <iframe :src="item.src" :alt="item.alt" allowfullscreen class="img-fluid" frameborder="0" loading="lazy"></iframe>
              </template>
              <template v-else-if="item.type === 'list'">
                <ul class="faq-list">
                  <li v-for="(line, k) in item.items" :key="k">
                    <strong v-if="line.bold" v-html="line.bold" class="faq-line"></strong>
                    <span v-if="line.text" v-html="line.text" class="faq-line"></span>
                  </li>
                </ul>
              </template>
              <template v-else-if="item.type === 'orderlist'">
                <ol class="faq-list">
                  <li v-for="(line, k) in item.items" :key="k">
                    <strong v-if="line.bold" v-html="line.bold" class="faq-line"></strong>
                    <span v-if="line.text" v-html="line.text" class="faq-line"></span>
                  </li>
                </ol>
              </template>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
     </div>
  </div>
</template>


<script>
export default {
  name: 'FAQ',
  computed: {
    faqList() {
      const faqs = this.$t('faq', 'faq-list');
      return Object.values(faqs);
    },    
  },
  methods: {
    closeIOSWebView() {
      if (typeof window.webkit !== 'undefined' &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.unityCloseWebView) {
        console.log("closeIOSWebView");
        window.webkit.messageHandlers.unityCloseWebView.postMessage(null);
      } else {
        console.log("Not in iOS WKWebView or handler not registered.");
      }
    }
  }
};
</script>

<style scoped>
.btn {
  padding: 6px 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
.btn:hover {
  background-color: #0056b3;
}
</style>

